import { render, staticRenderFns } from "./TheCustomersWithBothProducts.vue?vue&type=template&id=61516af4&"
import script from "./TheCustomersWithBothProducts.vue?vue&type=script&lang=js&"
export * from "./TheCustomersWithBothProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports